import http from '@/utils/http';
import camadas from '@/utils/camadas';
import i18n from '@/main';

export const GeoService = {
    getCamadas() {
        return new Promise(resolve =>
            resolve({
                data: camadas,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.buscandoCamadas')
            })
        );
    },

    getCarPorCoordenadas(lat, lng) {
        return http.post({
            url: 'territorios/espacial',
            data: { wkt: `POINT (${lng} ${lat})` },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCar')
        });
    }
};

export const CamadasService = {
    getCarPorCoordenadas(lat, lng) {
        return http.post({
            url: 'territorios/espacial',
            data: { wkt: `POINT (${lng} ${lat})` },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCar')
        });
    },
    inspecionarCamadas(camadas, geojson) {
        return http.post({
            url: `/diagnostico/inspecionar?camadas=${camadas}`,
            data: { arquivo: geojson },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoInspecaoDasCamadas'
            )
        });
    },

    buscarCamadas(filtro = '') {
        return http.get({
            url: `/camadas?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarQtdCamadasPorEmpresa(filtro, { pagina, tamanho }) {
        return http.post({
            url: `/empresas/camadas?page=${pagina - 1}&size=${tamanho}&sort=`,
            data: filtro,
            lockScreen: false
        });
    },

    buscarTotalCamadasVinculadas() {
        return http.get({
            url: 'camadas/vinculadas/total',
            lockScreen: false
        });
    },

    buscarCamadasPorEmpresa(idEmpresa) {
        return http.get({
            url: `camadas/vinculadas/${idEmpresa}`,
            lockScreen: false
        });
    },

    buscarCamadasUsuario() {
        return http.get({
            url: `camadas/buscar/camadas-usuario`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCamadasDoUsuario')
        });
    },

    vincularCamadasEmpresa(idEmpresa, idsCamadas) {
        return http.get({
            url: `camadas/vincular/${idEmpresa}?idsCamadas=${idsCamadas}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.vinculandoCamadaAsEmpresas')
        });
    },

    vincularCamadasEmpresas(idsEmpresas, idsCamadas) {
        return http.get({
            url: `camadas/vincular?idsEmpresas=${idsEmpresas}&idsCamadas=${idsCamadas}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.vinculandoCamadaAsEmpresas')
        });
    },

    removerCamadasEmpresas(idsEmpresas, idsCamadas) {
        return http.delete({
            url: `camadas/vinculadas?idsEmpresas=${idsEmpresas}&idsCamadas=${idsCamadas}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.desvinculandoCamadasDeEmpresas'
            )
        });
    },

    buscarCamadasVega() {
        return http.get({
            url: `camadas/buscar/camadas-vega`,
            lockScreen: false
        });
    },

    ultimaAtualizacao() {
        return http.get({
            url: `camadas/ultimaAtualizacao`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoAtualizacaoCamadas')
        });
    }
};
